import React from 'react';

type Props = {
    children?: React.ReactNode;
};

export default function PageWrapper({ children }: Props) {
    return <div className="page-wrapper desktop-res">{children}</div>;
}
